import { render } from "@/components/pages/dataMonitor/DataMonitorMeasure.html?vue&type=template&id=474fa48b&external"
import script from "@/components/pages/obd/individual/dataMonitor/ObdDataMonitorMeasure.js?vue&type=script&lang=js&external"
export * from "@/components/pages/obd/individual/dataMonitor/ObdDataMonitorMeasure.js?vue&type=script&lang=js&external"

import "@/components/pages/dataMonitor/DataMonitorMeasure.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__